'use strict'

/**
 * Simple implementation of lodash-esque `omit` for deleting certain properties from an object.
 * @param {Object} object - The parent object, containing one or more properties that we want to remove
 * @param {Array<string>} properties - An array of string values that map to properties on an object to delete.
 * @return {Object} A new object, comprised of all the properties minus the ones specified in the `properties` param.
 */

export default (object, properties) => {
    const output = Object.assign({}, object)
    properties.forEach((prop) => {
        delete output[prop]
    })
    return output
}
